/**
 * @description Wraps Connection Layer views, adding appropriate padding
 * and close functionality.
 */
import React from "react";
import PropTypes from "prop-types";

import "apps/messenger/components/Connections/shared/ViewContainer.scss";

const ViewContainer = ({ children, onClose }) => {
	return (
		<div className="connection-view-container">
			<div className="connection-view-container-close">
				<button
					type="button"
					onClick={onClose}
					className="connection-view-container-close-button"
				>
					<span className="icon i-close" />
				</button>
			</div>
			{ children }
		</div>
	);
};

ViewContainer.propTypes = {
	children: PropTypes.node.isRequired,
	onClose: PropTypes.func.isRequired,
};


export default ViewContainer;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/shared/ViewContainer.jsx